import {
    SetHead, HomeRouteChange, SetDefaultSeo, SetHomeSeo, SetProductSeo, SetCategorySeo, SetLookbookSeo, SetCategoryNoindex,
} from './infraestructure/state/seo.actions';
import { getHomeUrls, getLastSectionTranslated } from './infraestructure/state/seo.selectors';
import { SeoModule } from './seo.module';

export const SeoSelectors = {
    getHomeUrls,
    getLastSectionTranslated,
};

export const SeoActionTypes = {
    SetHead,
    HomeRouteChange,
    SetDefaultSeo,
    SetHomeSeo,
    SetProductSeo,
    SetLookbookSeo,
    SetCategorySeo,
    SetCategoryNoindex,
};

export const SeoPublicModule = SeoModule;
